import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'

const getGroupedSortedRegions = (regions) => {

  const grouped = regions
    .reduce((all, region) => {
      const districtName = region.districtName
      if (!(districtName in all)) {
        all[districtName] = []
      }
      all[districtName].push(region)
      return all
    }, {})

  const groups = Object.keys(grouped)
    .reduce((all, districtName) => {
      all[districtName] = [...grouped[districtName]]
        .sort((a, b) => a.title.localeCompare(b.title))
      return all
    }, {})

  return Object.keys(groups)
    .map((districtName) => ({
      districtName,
      regions: groups[districtName]
    }))
    .sort((a, b) => a.districtName.localeCompare(b.districtName))

}

function getActiveDistrictRegions(activeRegions, districtId) {
  return activeRegions
    .map((active) => window.APP_CONFIG.list_region
      .find((region) => region.id === active))
    .filter((active) => active.districtId === districtId)
}

function isDistrictActive(activeRegions, districtId, districtRegionsLength) {
  const activeDistrictRegions = getActiveDistrictRegions(activeRegions, districtId)
  return activeDistrictRegions.length === districtRegionsLength
}

const RegionsSection = observer(({ regions: activeRegions, section, onRemove }) => {
  const sortedGroups = getGroupedSortedRegions(window.APP_CONFIG.list_region)
  return (
    <section
      className={classNames('filter-definition', 'bg-tab-regions', {
        show: section === 'regions'
      })}
    >
      <h3 className="active">
        Landkreis
        <button className="btn btn-link reset-filter" onClick={onRemove}>
          <i className="glyphicon glyphicon-trash" />
        </button>
      </h3>
      <div className="scrollable">
        <div className="form-group region-filter">
          {
            sortedGroups
              .map(({ districtName, regions }) => {
                const districtId = regions[0].districtId
                const regionsLength = regions.length
                const value = window.APP_CONFIG.list_region
                  .filter((region) => region.districtId === districtId)
                  .map((region) => region.id)
                  .join(',')

                return (
                  <div key={districtName}>
                    <h5>
                      <label
                        htmlFor={`filter-region-${districtName}`}
                        className="small"
                      >
                        <input
                          type="checkbox"
                          id={`filter-region-${districtName}`}
                          name="region"
                          value={value}
                          checked={isDistrictActive(activeRegions, districtId, regionsLength)}
                        />
                        <span>{districtName}</span>
                      </label>
                    </h5>
                    {
                      regions.map((region) => {
                        return (
                          <div key={`region-${region.id}`}>
                            <label
                              htmlFor={`filter-region-${region.id}`}
                              className="small"
                            >
                              <input
                                type="checkbox"
                                id={`filter-region-${region.id}`}
                                name="region"
                                value={region.id}
                                checked={activeRegions.indexOf(region.id) !== -1}
                              />
                              <span>{region.title}</span>
                            </label>
                          </div>
                        )
                      })
                    }

                  </div>
                )
              })
          }
        </div>
      </div>
    </section>
  )
})

RegionsSection.propTypes = {
  onRemove: PropTypes.func.isRequired,
  regions: PropTypes.array,
  section: PropTypes.string
}

RegionsSection.componentName = 'RegionsSection'

export { RegionsSection as default }



// WEBPACK FOOTER //
// ./src/frontend/map/components/RegionsSection.js